import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

import { motion } from 'framer-motion';

import { cn } from 'src/shared/components/ui';

interface RfqDrawerTriggerProps {
  onClick: () => void;
  isDrawerOpen: boolean;
  /** Merged after base positioning (e.g. `z-[66]` on full-page overlays). */
  className?: string;
}

const RfqDrawerTrigger = ({
  onClick,
  isDrawerOpen,
  className
}: RfqDrawerTriggerProps) => {
  return (
    <motion.div
      key={isDrawerOpen ? 'open' : 'closed'}
      className={cn(
        'group cursor-pointer absolute z-[49] top-[64px]',
        isDrawerOpen
          ? 'left-[-2px] mobile:top-[64px]'
          : 'right-[-2px] mobile:top-0',
        className
      )}
      onClick={onClick}
      initial={{
        x: isDrawerOpen ? '-100%' : '100%'
      }}
      animate={{
        x: 0
      }}
      exit={{
        x: isDrawerOpen ? '-100%' : '100%'
      }}
      whileHover={{ scale: 1.2 }}
      transition={{
        ease: 'easeInOut',
        duration: 0.3
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="60"
        viewBox="0 0 37 60"
        fill="none"
        className={isDrawerOpen ? 'scale-x-[-1]' : ''}
      >
        <path
          d="M5.54419 19.8849C-1.84724 24.6029 -1.84723 35.3971 5.5442 40.1151L36.6973 60L36.6973 -2.05444e-06L5.54419 19.8849Z"
          fill="#000EEF"
          className="transition-colors duration-300 group-hover:fill-[black]"
        />
      </svg>

      {isDrawerOpen ? (
        <ChevronRightIcon className="size-4 text-white absolute top-1/2 -right-1 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      ) : (
        <ChevronLeftIcon className="size-4 text-white absolute top-1/2 left-1/3 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      )}
    </motion.div>
  );
};

export default RfqDrawerTrigger;
